import { render, staticRenderFns } from "./JsonTab.vue?vue&type=template&id=0b5a348c"
import script from "./JsonTab.vue?vue&type=script&lang=js"
export * from "./JsonTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports